// modules
import React from 'react';
import { View } from '@upstox/upstox-ui';
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';
import { ModalType } from 'modules/PriceAlerts/typings';
// components
import PriceAlertsListFooter from './PriceAlertsListFooter';
import CreatePriceAlertsFooter from './CreatePriceAlertsFooter';
import DeletePriceAlert from './DeletePriceAlert';
// styles
import * as css from './styles';

const PriceAlertsFooter: React.FC = () => {
  const { modalType } = useStore('PriceAlertsStore');
  const showBorder = modalType !== 'Delete';

  const renderModalFooter = (type: ModalType) => {
    switch (type) {
      case 'Create':
        return <CreatePriceAlertsFooter />;
      case 'List':
        return <PriceAlertsListFooter />;
      case 'Delete':
        return <DeletePriceAlert />;
      default:
        return <PriceAlertsListFooter />;
    }
  };

  return (
    <View cssProps={{ showBorder }} css={css.footer} padding="medium">
      {renderModalFooter(modalType)}
    </View>
  );
};

export default observer(PriceAlertsFooter);
